import { styled } from '@sparky/stitches';

export const SpanHeadingS = styled('span', { typography: '$headingS' });
